module.exports = (app) => app.factory('featureToggleService', /* @ngInject */ function (apiConfig, httpService) {


    function isActive(featureName) {
        const uri = apiConfig.getBase('feature', 'active');

        return httpService.post(uri.toString(), {featureNames: [featureName]}, {cache: true});
    }

    return {
        isActive,
    }
});